import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { PixQrCodeReturn } from '../../models/qr-code-return.model';
import { endpoints } from '../../../../../environments/environment';

@Injectable()
export class PixQrCodeDynamicService {
	private url = endpoints.pix;
	private pixQrCodeReturn: PixQrCodeReturn;

	constructor(private http: HttpClient) { }

	clearState(): void{
		this.pixQrCodeReturn = null;
	}

	getSelectedPixQrCodeReturn = () => this.pixQrCodeReturn;
	setSelectedPixQrCodeReturn = (pixQrCodeReturn: PixQrCodeReturn) => this.pixQrCodeReturn = pixQrCodeReturn;

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/pix/copy-and-paste/qr-code-dynamic/qr-code-dynamic.service.ts